<nz-drawer
  [nzVisible]="isDrawerVisible"
  [nzMask]="true"
  [nzMaskClosable]="true"
  nzPlacement="right"
  [nzFooter]="drawerFooter"
  [nzClosable]="false"
  [nzSize]="'large'"
  [nzTitle]="'page.qualifications.drawer.detail' | translate"
  (nzOnClose)="triggerCloseDrawerEvent()"
>
  <ng-container *nzDrawerContent>
    @if (qualificationDetails) {
      <wilson-user-qualification-v2-details-general-section
        [employee]="employee"
        [qualificationDetails]="qualificationDetails"
      ></wilson-user-qualification-v2-details-general-section>
      @if (routeId || sharedRouteData) {
        <hr />
        <wilson-route-knowledge-via-points
          [routeId]="routeId"
          [sharedRouteData]="sharedRouteData"
        ></wilson-route-knowledge-via-points>
      }
      <hr />
      <wilson-user-qualification-v2-details-attachment-section
        [userQualificationAttachments]="
          qualificationDetails.userQualificationAttachments
        "
        [canReadUserQualificationV2Attachments]="
          canReadUserQualificationV2Attachments
        "
      ></wilson-user-qualification-v2-details-attachment-section>
      <hr />
      <wilson-user-qualification-v2-details-history-section
        [userQualificationHistories]="
          qualificationDetails.userQualificationHistories
        "
      ></wilson-user-qualification-v2-details-history-section>
    }
  </ng-container>

  <ng-template #drawerFooter>
    <div class="drawer__footer">
      <button
        data-test="cancel-button"
        nz-button
        nzType="default"
        (click)="triggerCloseDrawerEvent()"
      >
        {{ 'general.cancel' | translate }}
      </button>
    </div>
  </ng-template>
</nz-drawer>
